<div id="subscription-status-banner" *ngIf="accountService.subscriptionExpired">
  <span class="important">Important:</span>
  Your {{ uiService.productName }} subscription has expired. You can still review and modify your account, but recovery
  points are not currently being captured and you are not able to execute tests or recoveries. You can renew your
  subscription
  <a [routerLink]="uiService.buildSubscriptionSettingsUrl(accountService.accountId)">here.</a>
</div>

<!-- This shows a banner if there is an AWS outage -->
<ng-container *ngIf="awsOutageObj$ | async as awsOutageObj">
  <div id="subscription-status-banner" *ngIf="awsOutageObj?.visible == true">
    <span class="important"> </span>
    <span [innerHtml]="awsOutageObj?.safeHtml"></span>
  </div>
</ng-container>

<account-navigation [account-id]="accountId" [initialized]="initialized"></account-navigation>
